// Logger utility for TestHR application
// Provides consistent logging interface across the application

const logger = {
    // Info level logging
    info() {
        // Info logging disabled in production
    },

    // Debug level logging
    debug() {
        // Debug logging disabled in production
    },

    // Warning level logging
    warn() {
        // Warning logging disabled in production
    },

    // Error level logging
    error() {
        // Error logging disabled in production
    }
}

export default logger
